import { Outlet } from 'react-router-dom'
import { Mobile, Pc } from './hooks/MediaQuery'
import HeaderPc from './components/HeaderPc'
import BottomBarPc from './components/BottomBarPc'
import HeaderMobile from './components/HeaderMobile'
import BottomBarMobile from './components/BottomBarMobile'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { useLocation } from 'react-router-dom'
export default function NavbarLayout() {
  const location = useLocation()

  return (
    <div>
      <Pc>
        <HeaderPc />
        <BottomBarPc />
      </Pc>
      <Mobile>
        <HeaderMobile />
        <BottomBarMobile />
      </Mobile>
      <TransitionGroup>
        <CSSTransition key={location.key} classNames="fade" timeout={500}>
          <div>
            <Outlet />
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
}
